import { gql } from "@apollo/client";

export const UPDATE_BOOKING_SCHEDULE = gql`
  mutation modifyBookingSchedule($data: ModifyBookingScheduleInput!) {
    modifyBookingSchedule(data: $data) {
      id
    }
  }
`;